import axios from "@/utils/axios";

export const getUserInfo = (data) => {
  return axios.post({
    url: "/getUserInfo",
    data,
  });
};

export const getUserInfoNew = () => {
  return axios.get({
    url: "/v1/sso-user/user/getBaseUserInfo",
  });
};


export const updatePassword = (data) => {
  return axios.post({
    url: "/updatePassword",
    data,
  });
};

export const updateUserInfo = (data) => {
  return axios.post({
    url: "/updateUserInfo",
    data,
  });
};

// 解除第三方账号绑定
export const removeThirdpartyAccount = (data) => {
  return axios.post({
    url: "/removeThirdpartyAccount",
    data,
  });
};